export const InitialPage = 0;